import React, { Fragment, useState, useEffect } from 'react';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import numeral from 'numeral';

import Alerts from '../../utils/alerts';
import agm from '../../services/agm';

import {
    KeyboardDatePicker
} from '@material-ui/pickers';

import NumberFormat from 'react-number-format';

import {
    Tooltip,
    Avatar,
    Button,
    Box,
    colors,
    Icon,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer,
    TableFooter,
    Typography,
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Grid,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    TextField,
    Card,
    CardContent,
    withStyles,
    FormControlLabel,
    Checkbox,
    IconButton
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    avatar: {
        marginRight: theme.spacing(1),
        backgroundColor: colors.grey[200]
    },
    container: {
        maxHeight: 340,
    },
    input: {
        color: colors.cyan['A700']
    },
    inputErro: {
        color: colors.red[900]
    },
    products: {
        padding: 0
    }
}));

const defaultProductLpu = {
    codigo: null,
    nome: null,
    UNIDADE: null,
    valor: 0.0,
    instalacao: 0.0,
    APLICACAO: null,
    REGIAO: -1
}

const Create = ({ item, open, closeCreation, createValues, dependencies, selectedMode }) => {

    const classes = useStyles();
    const [openAlert, setOpenAlert] = useState(false);
    const [message, setMessage] = useState({});

    const requestOcorrence = async (value, values) => {
        if (value != '') {
            await agm.get('/orcamentos/ocorrencia/' + value, {}, {}).then((response) => {
                if (!response.data.error) {
                    var list = response.data;
                    if (list.length > 0) {
                        var ocorrencia = list[0];
                        values.idOcorrencia = ocorrencia.id;
                        values.ccusto = ocorrencia.unidade.codigo;
                        values.unidade = ocorrencia.unidade.nome;
                        values.abertura = ocorrencia.abertura;
                        values.tipoOcorrencia = ocorrencia.tipoOcorrencia.nome;
                        values.categoria = ocorrencia.categoria.nome;
                        values.valorMaoObra = 0.0;
                        values.valorMaterial = 0.0;
                        values.idProduto = '';
                        values.qtdProduto = '';
                        values.codigoProduto = '';
                        values.nomeProduto = '';
                        values.lpuProduto = '';
                        values.custoProduto = '';
                        values.bdiProduto = '';
                        values.valorProduto = '';
                        values.instalacaoProduto = '';
                        values.produto = null;
                        document.getElementById('ORCAMENTISTA').focus();
                    }
                } else {
                    values.ocorrencia = '';
                    values.idOcorrencia = null;
                    values.ccusto = '';
                    values.unidade = '';
                    values.abertura = null;
                    values.tipoOcorrencia = '';
                    values.categoria = '';
                    values.idProduto = ''
                    values.valorMaoObra = 0.0;
                    values.valorMaterial = 0.0;
                    values.qtdProduto = '';
                    values.codigoProduto = '';
                    values.nomeProduto = '';
                    values.lpuProduto = '';
                    values.custoProduto = '';
                    values.bdiProduto = '';
                    values.valorProduto = '';
                    values.instalacaoProduto = '';
                    values.produto = null;
                    setMessage(response.data);
                    setOpenAlert(true);
                }
            }).catch((error) => {
                console.error(error);
                setMessage({ error: true, fatal: true, message: error.message });
                setOpenAlert(true);
            })
        }
    }

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    return (
        <Fragment>

            <Alerts message={message}
                open={openAlert}
                closeAlert={closeAlert} />

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" fullWidth>
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Novo Orçamento
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                ocorrencia: Yup.string().required('Ocorrência é obrigatória')
                            })
                        }
                        onSubmit={(values, formik) => {
                            createValues(values, dependencies.items, dependencies.removes);
                            formik.setSubmitting(false);
                        }}

                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (

                            <form onSubmit={handleSubmit}>

                                <Box className={classes.root} mt={1} >

                                    <Grid
                                        container
                                        spacing={2}
                                        xs="auto"
                                    >

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.ocorrencia && errors.ocorrencia)}
                                                fullWidth
                                                required
                                                label="Ocorrência"
                                                margin="none"
                                                id="ocorrencia"
                                                name="ocorrencia"
                                                onBlur={e => {
                                                    requestOcorrence(e.currentTarget.value, values);
                                                    handleBlur(e);
                                                }}
                                                onChange={handleChange}
                                                value={values.ocorrencia}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={
                                                    { readOnly: false, }
                                                }
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.ccusto && errors.ccusto)}
                                                fullWidth
                                                required
                                                label="Centro Custo"
                                                margin="none"
                                                name="ccusto"
                                                id="ccusto"
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("ccusto", value)}
                                                value={values.ccusto}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={8}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.unidade && errors.unidade)}
                                                fullWidth
                                                required
                                                label="Unidade"
                                                margin="none"
                                                name="unidade"
                                                id="unidade"
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("unidade", value)}
                                                value={values.unidade}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                error={Boolean(touched.abertura && errors.abertura)}
                                                fullWidth
                                                required
                                                readOnly
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                inputVariant="outlined"
                                                id="abertura"
                                                label="Data de Ocorrência"
                                                format="DD/MM/YYYY"
                                                name="abertura"
                                                value={values.abertura}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("abertura", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.tipoOcorrencia && errors.tipoOcorrencia)}
                                                fullWidth
                                                required
                                                label="Tipo"
                                                margin="none"
                                                id="tipoOcorrencia"
                                                name="tipoOcorrencia"
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("tipoOcorrencia", value)}
                                                value={(values.tipoOcorrencia) ? values.tipoOcorrencia : "Não Informada"}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>


                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.categoria && errors.categoria)}
                                                fullWidth
                                                required
                                                label="Categoria"
                                                margin="none"
                                                name="categoria"
                                                id="categoria"
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("categoria", value)}
                                                value={(values.categoria) ? values.categoria : "Não Informada"}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid

                                            item
                                            md={2}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.numero && errors.numero)}
                                                fullWidth
                                                required
                                                label="Orçamento"
                                                margin="none"
                                                name="numero"
                                                id="numero"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={numeral(values.numero).format('000000')}
                                                variant="outlined"
                                                inputProps={
                                                    { readOnly: true, }
                                                }
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                required
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                inputVariant="outlined"
                                                id="dataCriacao"
                                                label="Data de Criação"
                                                format="DD/MM/YYYY"
                                                name="dataCriacao"
                                                value={values.dataCriacao}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("dataCriacao", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none">
                                                <InputLabel shrink htmlFor="FASE_ORCAMENTO" required >Fase de Orçamento</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    required
                                                    readOnly
                                                    error={Boolean(touched.FASE_ORCAMENTO && errors.FASE_ORCAMENTO)}
                                                    helperText={touched.FASE_ORCAMENTO && errors.FASE_ORCAMENTO}
                                                    value={values.FASE_ORCAMENTO}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Fase de Orçamento"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'FASE_ORCAMENTO',
                                                        id: 'FASE_ORCAMENTO',
                                                    }}
                                                >
                                                    <MenuItem key={-1} value={null}>
                                                        <em>Selecione um</em>
                                                    </MenuItem>

                                                    {dependencies.phases.map((phase) => (
                                                        <MenuItem key={phase.id} value={phase.id}>{phase.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <FormControl variant="outlined" fullWidth margin="none">
                                                <InputLabel shrink htmlFor="ORCAMENTISTA" required >Orçamentista</InputLabel>
                                                <Select notched
                                                    autosize={true}
                                                    error={Boolean(touched.ORCAMENTISTA && errors.ORCAMENTISTA)}
                                                    helperText={touched.ORCAMENTISTA && errors.ORCAMENTISTA}
                                                    value={values.ORCAMENTISTA}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Orçamentista *"
                                                    variant="outlined"
                                                    inputProps={{
                                                        name: 'ORCAMENTISTA',
                                                        id: 'ORCAMENTISTA',
                                                    }}
                                                >
                                                    <MenuItem key={-1} value={null}>
                                                        <em>Selecione um</em>
                                                    </MenuItem>

                                                    {dependencies.makers.map((maker) => (
                                                        <MenuItem key={maker.id} value={maker.id}>{maker.nome}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <KeyboardDatePicker
                                                fullWidth
                                                cancelLabel="Cancelar"
                                                margin="none"
                                                inputVariant="outlined"
                                                id="dataEnvio"
                                                label="Data de Envio"
                                                format="DD/MM/YYYY"
                                                name="dataEnvio"
                                                value={values.dataEnvio}
                                                onBlur={handleBlur}
                                                onChange={value => setFieldValue("dataEnvio", value)}
                                                KeyboardButtonProps={{
                                                    'aria-label': 'change date',
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>



                                    </Grid>

                                </Box>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>

                                    <Grid container
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Criar
                                            </Button>
                                        </Grid>

                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeCreation() }}>
                                                Fechar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Create;
